'use strict';
var isObject = require('../internals/is-object');

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/is-possible-prototype.js
// module id = 673
// module chunks = 13